/**
 * Buybox-1 Bootstrap Script
 * Global trigger listener and modal loader
 * Based on preorder bootstrap patterns for consistency
 */

(function() {
  'use strict';
  
  let modalLoaded = false;
  let modalScriptsLoaded = false;
  
  /**
   * Load the main modal bundle and dependencies
   */
  function loadBuybox1() {
    if (modalLoaded) {
      window.Buybox1.open().catch(error => {
        console.warn('Failed to open Buybox-1:', error);
      });
      return;
    }
    
    if (modalScriptsLoaded) return;
    modalScriptsLoaded = true;
    
    // Load CSS first
    const cssUrl = window.BuyboxAssetUrls1.css;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    document.head.appendChild(link);
    
    // Load scripts sequentially to ensure proper dependency order
    const scriptsToLoad = window.BuyboxAssetUrls1.scripts;
    
    let currentScriptIndex = 0;
    
    function loadNextScript() {
      if (currentScriptIndex >= scriptsToLoad.length) {
        // All scripts loaded, initialize modal
        modalLoaded = true;
        window.Buybox1.init();
        // Ensure modal becomes visible when JS is ready
        const root = document.getElementById('buybox-1-modal');
        if (root) root.style.display = '';
        window.Buybox1.open().catch(error => {
          console.warn('Failed to open Buybox-1:', error);
        });
        return;
      }
      
      const script = document.createElement('script');
      script.src = scriptsToLoad[currentScriptIndex];
      script.onload = () => {
        currentScriptIndex++;
        loadNextScript();
      };
      script.onerror = () => {
        // Failed to load script - silent fail for production
        currentScriptIndex++;
        loadNextScript();
      };
      document.head.appendChild(script);
    }
    
    loadNextScript();
  }
  
  /**
   * Handle trigger clicks
   */
  function handleTriggerClick(e) {
    const target = e.target.closest('a[href="#buybox-1"]');
    if (!target) return;
    
    e.preventDefault();
    
    // Load and open modal
    loadBuybox1();
    
    // Track analytics after modal opens
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'buybox-1_opened', {
          source: target.textContent.trim() || target.getAttribute('aria-label') || 'unknown_trigger',
          page: window.location.href
        });
      }
    }, 100);
  }
  
  /**
   * Setup global event listeners
   */
  function setupEventListeners() {
    // Listen for trigger clicks
    document.addEventListener('click', handleTriggerClick, true);
    
    // Listen for hash changes (in case someone navigates to #buybox-1)
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#buybox-1') {
        loadBuybox1();
      }
    });
    
    // Check if page was loaded with hash
    if (window.location.hash === '#buybox-1') {
      loadBuybox1();
    }
  }
  
  /**
   * Initialize bootstrap when DOM is ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupEventListeners);
    } else {
      setupEventListeners();
    }
  }
  
  // Initialize
  init();
  
})();
